import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal } from "@material-ui/core";
import { FaMapMarkerAlt } from "react-icons/fa";
import { Spinner } from "react-bootstrap";

import { getTrackingInfo } from "../../actions/packages";
import "./ViewPackage.scss";

class ViewPackage extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.pkg !== nextProps.pkg) {
      const pkg = nextProps.pkg;

      // fetch tracking info
      if (pkg.tracking) this.props.getTrackingInfo(pkg);
    }
  }

  render() {
    const { open, onClose, color, pkg } = this.props;
    return (
      <Modal
        id="viewPackageModal"
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={onClose}
      >
        <div className="modalContainer" style={{ backgroundColor: color }}>
          <h1>{pkg.name || <span>&nbsp;</span>}</h1>
          {pkg.deliveryDate && (
            <div className="spaceBetweenDiv">
              <p>
                <b>Delivery by: </b>
              </p>
              <p>{pkg.deliveryDate}</p>
            </div>
          )}

          {pkg.tracking && (
            <div className="spaceBetweenDiv">
              <p>
                <b>Tracking #: </b>
              </p>
              <p>{pkg.tracking}</p>
            </div>
          )}
          {pkg.location && (
            <div className="spaceBetweenDiv">
              <p>
                <b>Location: </b>
              </p>
              <p className="packageLocation">
                <FaMapMarkerAlt />
                {pkg.location}
              </p>
            </div>
          )}
          {pkg.unlockID && (
            <div className="spaceBetweenDiv">
              <p>
                <b>Unlock Code: </b>
              </p>
              <p>{pkg.unlockID}</p>
            </div>
          )}
          {pkg.unlockID && (
            <div className="barCodeDiv">
              <img
                src={require("../../assets/demo/sample-barcode.png")}
                alt="bar code"
              />
            </div>
          )}
          {pkg.tracking && (
            <div>
              <p className="trackingUpdatesTitle">
                <b>Tracking Updates: </b>
              </p>
              {pkg.trackingInfo ? (
                <div
                  className="trackingUpdates"
                  dangerouslySetInnerHTML={{
                    __html: pkg.trackingInfo.carrier_status_description
                  }}
                />
              ) : (
                <div className="trackingSpinner">
                  <Spinner animation="border" variant="light" />
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

ViewPackage.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  color: PropTypes.string,
  pkg: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch => ({
  getTrackingInfo: pkg => dispatch(getTrackingInfo(pkg))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewPackage);
